import { Component, HostListener, ViewChild } from '@angular/core';
import {faFacebook,faGoogle,faInstagram,faLinkedin,faPinterest,faTumblr,faTwitter,
} from '@fortawesome/free-brands-svg-icons';
import { NgForm } from '@angular/forms';
import {
  faMountainCity,
  faUser,faNewspaper,
  faTree,faMoon,faLandmarkAlt,
  faExclamationCircle,
  faKey,faShip,
  faAddressCard,
  faHotel,
  faPlaneDeparture,
  faUserPlus, faPhone, faPlaneUp, faEnvelope, faLocationDot, faPassport, faThumbsUp, faRotateForward, faUserCheck,
} from '@fortawesome/free-solid-svg-icons';
import { Sidebar } from 'primeng/sidebar';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
//import {
//  HomeLandingCenterSection,
//  HomeSocialIcons,
//  HomeWelcomeSection,
//} from '../Models/HomeComponentProperties';
import { LoginUserProperties, } from '../Models/UsersProperties';
import { AuthService } from '../Services/auth.service';
import { CMSService } from '../Services/cms.service';
import { CmsLoginHeaderProperties, CmsLogoProperties, GetAllCmsLoginProperties } from '../Models/CmsLoginHeaderProperties';
import { CmsLoginMainContentProperties, OTPLogin } from '../Models/CmsLoginMainContentProperties';

import { HomeComponentServicesService } from '../Services/home-component-services.service';
import { MessageService } from 'primeng/api';
import { CmsFooterContactsProperties, CmsFooterSocialProperties } from '../Models/CmsFooterContactsProperties';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CmsContactUsFormProperties, CmsContactUsProperties } from '../Models/CmsContactUsProperties';
import { EmailItineraryProperties } from '../Models/ERPProperties';
import { EmailItineraryService } from '../Services/emailItinerary.service';
import { CmsAboutUsLandingProperties } from '../Models/CmsAboutUsProperties';
import { faClock, faLightbulb, faSmile } from '@fortawesome/free-regular-svg-icons';
import { AgencyService } from '../Services/Agency.service';
import { UsersService } from '../Services/users.service';
@Component({
  selector: 'app-home-new',
  templateUrl: './home-new.component.html',
  styleUrls: ['./home-new.component.css'],
})
export class HomeNewComponent {
  contactUsForm = new CmsContactUsFormProperties();
  loginCred = new LoginUserProperties();
  allData$: GetAllCmsLoginProperties;
  loginLanding: CmsLoginMainContentProperties[] = [];
  otp = new OTPLogin();
  faFacebook = faFacebook;
  androidPath = environment.androidPath;
  faPhone = faPhone;
  faPlaneUp = faPlaneUp;
  faEnvelope = faEnvelope;
  faLocationDot = faLocationDot;
  faPassport = faPassport;
  faInstagram = faInstagram;
  faTwitter = faTwitter;
  faLinkedin = faLinkedin;
  faGoogle = faGoogle;
  faMoon = faMoon;
  faLandmarkAlt = faLandmarkAlt;
  fasmile = faSmile;
  faclock = faClock;
  farotate = faRotateForward;
  fausercheck = faUserCheck;
  fabulb = faLightbulb;
  fathumbs = faThumbsUp;
  faNewspaper = faNewspaper;
  faAddressCard = faAddressCard;
  faPlaneDeparture = faPlaneDeparture;
  faPinterest = faPinterest;
  faTumblr = faTumblr;
  faUser = faUser;
  faShip = faShip;
  faTree = faTree;
  faHotel = faHotel;
  faKey = faKey;
  faExclamationCircle = faExclamationCircle;
  faUserPlus = faUserPlus;
  faMountain = faMountainCity;
  companyName = environment.companyName;
  spinner: boolean = false;
  dataotpform: boolean = false;
  valid = true;
  logo = '';
  otpSection: boolean = false;
  contentHome: boolean = false;
  loginSection: boolean = true;
  changenewpassSection: boolean = false;
  agencyId: string = 'AG01';
  isMobileView: boolean = false;
  position: string = 'top';
  contacusbool: boolean = false;
  dynamicSrc: string = "";
  landingData: CmsAboutUsLandingProperties[] = [];
  footerSocial: CmsFooterSocialProperties[] = [];
  footerContacts: CmsFooterContactsProperties[] = [];
  // loginCred = new HomeWelcomeSection();
  contactUs: CmsContactUsProperties[] = [];
  emailproperties = new EmailItineraryProperties();
  @ViewChild('sidebarRef', { static: false }) sidebarRef!: Sidebar;
  url: SafeResourceUrl;
  closeCallback(e): void {
    this.sidebarRef.close(e);
  }
  visible: boolean = false;

  showDialog(position: string) {
    this.position = position;
    this.visible = true;
  }
  PasteTheOTP(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData || window['clipboardData'];
    const pastedText = clipboardData.getData('text');
 
    if (pastedText.length === 6) {
      this.otp.digit1 = pastedText[0];
      this.otp.digit2 = pastedText[1];
      this.otp.digit3 = pastedText[2];
      this.otp.digit4 = pastedText[3];
      this.otp.digit5 = pastedText[4];
      this.otp.digit6 = pastedText[5];

      // Set focus to the last field after pasting
      setTimeout(() => {
        const digit6Field = document.getElementById('digit6');
        if (digit6Field) {
          digit6Field.focus();
        }
      }, 0);

      // Prevent the default paste action
      event.preventDefault();
    }
  }
 
  showadminInfoPassowrd() {
    var x = document.getElementById("tbpassword") as HTMLInputElement;

    if (x.type === "password") {
      x.type = "text";
      document.getElementById("togglePassword").classList.toggle("fa-eye");
      document.getElementById("togglePassword").classList.remove("fa-eye-slash");
    } else {
      x.type = "password";
      document.getElementById("togglePassword").classList.add("fa-eye-slash");
      document.getElementById("togglePassword").classList.remove("fa-eye");
    }
  }

  onSubmit(dataform: NgForm) {
    this.contacusbool = true;
    if (!dataform.valid) {
      return;
    }
    try {
      this.spinner = true;
      this.cmsService.userLoginEmail(this.loginCred).subscribe((data) => {
    
        if (data.isAuthorized == true) {
          this.loginCred = data;
          this.spinner = false;
          if (data.userActive == true) {
            this.loginCred.otp = "";

            this.otpSection = true;
            this.changenewpassSection = false;
            this.loginSection = true;
            this.loginCred.password = "";


          }
          else {
            this.loginCred.otp = "";
            this.otpSection = false;
            this.secretkeyopen = true;
            this.loginSection = true;


          }

        }
        else {
          this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Unauthorized..!' });

        }
      });
    }
    catch (e) {
      //console.log(e);
    }
  }
  sidebarVisible: boolean = false;
  //sections = [
  //  { title: 'Awesome Experience for Tourism & Travel', content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non est massa. Praesent rutrum aliquet arcu odio, non porttitor quam tristique nec. Vestibulum ante ipsum primis in faucibus cubaailiaCurae; Phasellus gravida sed arcu mattis sodales.' }
  //  // Add more sections as needed
  //];
  //@HostListener('window:scroll', ['$event'])
  //onWindowScroll() {
  //  const sections = document.getElementsByClassName('touristpoint-content-post-full');
  //  Array.from(sections).forEach(section => {
  //    const scrollPosition = window.scrollY;
  //    const sectionTop = (section as HTMLElement).getBoundingClientRect().top + window.scrollY;
  //    const sectionHeight = (section as HTMLElement).clientHeight;
  //    const scrollEffect = (scrollPosition - sectionTop) / sectionHeight * 100;
  //    const sectionElement = section as HTMLElement; // Cast to HTMLElement
  //    sectionElement.style.backgroundPositionY = `${scrollEffect}%`;
  //  });
  //}
  responsiveItems: any[] = [
    {
      breakpoint: '576px',
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: '767px',
      numVisible: 3,
      numScroll: 1,
    },
  ];
  playInterval = 3000;
  menuItems = [
    { label: 'FLIGHT', icon: 'pi pi-send' },
    { label: 'HOTEL', icon: 'pi pi-home' },
    { label: 'HOLIDAYS', icon: 'pi pi-calendar' },
    { label: 'VISA', icon: 'pi pi-id-card' },
    { label: 'INSURANCE', icon: 'pi pi-briefcase' },
    { label: 'CRUISE', icon: 'pi pi-globe' },
    { label: 'UMRAH', icon: 'pi pi-moon' }
  ];

  constructor(private emailService: EmailItineraryService, private sanitizer: DomSanitizer, private messageService: MessageService, public cmsService: CMSService, private router: Router, private authservice: AuthService, private agencyService: AgencyService, private userService: UsersService) {}

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkScreenWidth();
  }
  ngOnInit() {
    
    // this.HomePageData();
    this.checkScreenWidth();
    this.getAllData();
    this.getContactData();
    this.getdata();
    this.transform();
    let userid = Number(localStorage.getItem("UserId"));
    let agencyId = localStorage.getItem("AgencyId");
    if (userid > 0 && userid != null && userid != undefined && agencyId != null && agencyId != undefined && agencyId != "") {
      localStorage.clear();
      //let timelogin : string | null;
      // timelogin = String(localStorage.getItem("TimeOfLogin"));
      // let datetimefuture = new Date(JSON.parse(timelogin));

      //let datenow = new Date();
      ////console.log("datenow", datenow);
      //if (datenow < datetimefuture) {

      //  this.router.navigateByUrl('/flightSearch');
      //}
      //else {

      //  window.localStorage.setItem('logout-event', Math.random().toString());
      //  this.authservice.logOut();
      //  this.router.navigateByUrl('/home');
      //}
    }
    else {
      localStorage.clear();
      //this.getAllData();
      // history.pushState(null, '', window.location.href);

      // this.Location.onPopState(() => {

      //   history.pushState(null, '', window.location.href);

      // });
    }
    // this.userLogin();
    //this.GetChildAgencyRight('AG01');
  }
  getdata() {

    this.cmsService.getFooterData().subscribe((data) => {


      this.footerContacts = data.footerContacts;


    });
  }
  transform() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      this.dynamicSrc
    );
  }
  SubmitReq() {
    if (this.contactUsForm.firstName == undefined || this.contactUsForm.firstName == "" || this.contactUsForm.firstName == null) {
      /*   message id here*/

      /*      box input id here*/
      document.getElementById("firstinput").classList.add("newRequired-BoxColor");

      setTimeout(function () {
      
        document.getElementById("firstinput").classList.remove("newRequired-BoxColor");


      }
        , 6000);
    }
    if (this.contactUsForm.lastName == undefined || this.contactUsForm.lastName == "" || this.contactUsForm.lastName == null) {
      /*   message id here*/

      /*      box input id here*/
      document.getElementById("lastinput").classList.add("newRequired-BoxColor");

      setTimeout(function () {

        document.getElementById("lastinput").classList.remove("newRequired-BoxColor");


      }
        , 6000);
    }
    if (this.contactUsForm.emailUser == undefined || this.contactUsForm.emailUser == "" || this.contactUsForm.emailUser == null) {
      /*   message id here*/

      /*      box input id here*/
      document.getElementById("emaiinput").classList.add("newRequired-BoxColor");

      setTimeout(function () {

        document.getElementById("emaiinput").classList.remove("newRequired-BoxColor");
      }
        , 6000);
    }
    if (this.contactUsForm.message == undefined || this.contactUsForm.message == "" || this.contactUsForm.message == null) {
      /*   message id here*/

      /*      box input id here*/
      document.getElementById("messageinput").classList.add("newRequired-BoxColor");

      setTimeout(function () {

        document.getElementById("messageinput").classList.remove("newRequired-BoxColor");
      }
        , 6000);
    }
    if (this.contactUsForm.message == undefined || this.contactUsForm.message == "" || this.contactUsForm.message == null ||
      this.contactUsForm.emailUser == undefined || this.contactUsForm.emailUser == "" || this.contactUsForm.emailUser == null ||
      this.contactUsForm.firstName == undefined || this.contactUsForm.firstName == "" || this.contactUsForm.firstName == null ||
      this.contactUsForm.lastName == undefined || this.contactUsForm.lastName == "" || this.contactUsForm.lastName == null
    ) {
      return;
    }
    this.emailproperties.customerEmail = "info@oktravelsgroup.com";


    this.emailproperties.subject = "Contact this person";
    this.emailproperties.body = "Contact this person";
    this.emailproperties.customerName = this.contactUsForm.firstName + " " + this.contactUsForm.lastName;
    this.emailproperties.body = `
             <div style="flex: 0 0 33.333333%;max-width: 33.333333%;">
               <div style="padding:30px;">
               <div style="display: flex; justify-content: center;">
<h2>
Contact Person Details
</h2>
</div>
<div style="display: flex;flex-wrap: wrap;">
<div style="flex: 0 0 33.333333%;max-width: 33.333333%; display: flex;align-content: center;justify-content: center;">
    <div>


<h3 style="font-weight: bold; ">
    Name:
</h3>
</div>

</div>
<div style="flex: 0 0 66.666667%; max-width: 66.666667%; display: flex;align-content: center;justify-content: center;">
<h3>
    ${this.emailproperties.customerName}
</h3>
</div>
</div>

<div style="display: flex;flex-wrap: wrap;">
<div style="flex: 0 0 33.333333%;max-width: 33.333333%; display: flex;align-content: center;justify-content: center;">
    <div>
<h3 style="font-weight: bold;">
    Email:
</h3>
</div>

</div>
<div style="flex: 0 0 66.666667%;max-width: 66.666667%; display: flex;align-content: center;justify-content: center;">
<h3>
    ${this.contactUsForm.emailUser}
</h3>
</div>
</div>

<div style="display: flex;flex-wrap: wrap;">
<div style="flex: 0 0 33.333333%;max-width: 33.333333%; display: flex;align-content: center;justify-content: center;">
    <div>
<h3 style="font-weight: bold; ">
    Message:
</h3>
</div>

</div>
<div style="flex: 0 0 66.666667%;max-width: 66.666667%; display: flex;align-content: center;justify-content: center;">
<h3>
   ${this.contactUsForm.message}
</h3>
</div>
</div>

    </div>
        </div>
`;
    this.emailService.emailItinerary(this.emailproperties).subscribe((data) => {

      if (data == true) {
        document.getElementById("messageEmail").innerHTML = 'Email Sent';
        setTimeout(() => { document.getElementById("messageEmail").innerHTML = ''; }, 5000);
      }
      else {
        document.getElementById("messageEmail").innerHTML = 'Please Try Again!';
        setTimeout(() => { document.getElementById("messageEmail").innerHTML = ''; }, 5000);
      }
    })
  }
  getContactData() {
    try {
      this.cmsService.getContactUs().subscribe((data) => {
        this.contactUs = data;
        this.dynamicSrc = data[0].map;
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.dynamicSrc);
      });
    }
    catch (e) {
      //console.log(e);
    }
  }
  //baseData$: HomeWelcomeSection = new HomeWelcomeSection();
  checkScreenWidth() {
    this.isMobileView = window.innerWidth <= 767;
  }

  Welcome_title: string = '';
  Welcome_Description: string = '';
  Welcome_ImageName: string = '';
  HomePage_Id: string = '';
  //HomeLandingCenter = new HomeLandingCenterSection();
  //HomeSocial = new HomeSocialIcons();
  //HomePageData() {
  //  this.homeService
  //    .getHomeLandingData('AG01')
  //    .subscribe((data: HomeWelcomeSection) => {
  //      this.baseData$.homeWelcomeData = data.homeWelcomeData;
  //      this.baseData$.homeIconsObj = data.homeIconsObj;
  //      this.HomeLandingCenter = data.homeWelcomeData;
  //      // this.Welcome_title = this.baseData$.homeWelcomeData.title;
  //      // this.Welcome_Description = this.baseData$.homeWelcomeData.description;
  //      // this.Welcome_ImageName = this.baseData$.homeWelcomeData.imageName;
  //      // this.HomePage_Id = this.baseData$.homeWelcomeData.id;
  //    });
  //}
  responsiveOptions: any[] = [];
  responsiveOptions2: any[] = [
    {
      breakpoint: '576px',
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: '767px',
      numVisible: 3,
      numScroll: 1,
    },
  ];


  objects: any[] = [
    { img: '../../assets/Airlines/EK.png' },
    { img: '../../assets/Airlines/ER.png' },
    { img: '../../assets/Airlines/FZ.png' },
    { img: '../../assets/Airlines/G9.png' },
    { img: '../../assets/Airlines/PA.png' },
    { img: '../../assets/Airlines/PF.png' },
    { img: '../../assets/Airlines/PK.png' },
    { img: '../../assets/Airlines/QR.png' },
  ];

  toCapitalLettersForAgency(str, e) {
   
    if (str == undefined && str == null && str == "") {
      return
    }
    var event = e.target.id;

    var agencyid = document.getElementById("agencyid") as HTMLInputElement;
    var newagencyid = agencyid.id;


    if (event == newagencyid) {
      var capitalizeticketpnr = str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toUpperCase();
        }

      );
      this.loginCred.agencyId = capitalizeticketpnr;
    }

  }



      getAllData() {
        try {
          try {
            this.cmsService.getAboutUsLanding().subscribe((data) => {
              this.landingData = data;
            });
          }
          catch (e) { //console.log(e);
          }
          this.cmsService.getAllLoginPageData().subscribe((data) => {
            this.allData$ = data;
            this.loginLanding = this.allData$.loginLanding;
          
            this.logo = this.allData$.logo[0].logo;
            this.contentHome = true;
          });
        } catch (e) { }
      }
      public verifyOTP=(dataform:any)=> {
        this.dataotpform = true;
        if (dataform.Invalid) {
          return;
        }
        try {
          this.loginCred.otp=this.otp.digit1+this.otp.digit2+this.otp.digit3+this.otp.digit4+this.otp.digit5+this.otp.digit6;
          this.cmsService.emailOTPVerify(this.loginCred).subscribe((data) => {
            ////console.log("Verify Response: " + data);
            if (data == true) {
              //this.authservice.login();
              localStorage.setItem("ParentHierarchy", this.loginCred.parentHierarchy);
              localStorage.setItem("UserId", this.loginCred.userId.toString());
              localStorage.setItem("AgencyId", this.loginCred.agencyId);
              localStorage.setItem("Phone", this.loginCred.mobile);
              localStorage.setItem("fullName", this.loginCred.fullName);
              localStorage.setItem("ParentAgency", this.loginCred.parentAgency);
              localStorage.setItem("UserActive", String(this.loginCred.userActive))
              localStorage.setItem("ImmediateParent", this.loginCred.immediateParent);
              localStorage.setItem("BackSystemCompanyId", this.loginCred.backSystemCompanyId.toString());
              localStorage.setItem("BackSystemCompanyCustomer", this.loginCred.backSystemCompanyCustomer);
              localStorage.setItem("AgencyCurrency", this.loginCred.agencyCurrency);
              var operatingCountry = environment.operatingCountry;
              if (operatingCountry == 'Pakistan') {
                this.agencyService.GetUserRoleName(this.loginCred.userId).subscribe(roleName => {

                  console.log("LoginUserRoleName Name: ", roleName);
                  // set in local storage AFTER receiving
                  localStorage.setItem("LoginUserRoleName", roleName);

                });
              }
              // Fetch and store navigation menu permissions
              this.fetchUserPermissions(this.loginCred.agencyId, this.loginCred.userId.toString());
              this.authservice.login();
              this.otpSection = false;
              this.changenewpassSection = false;
              this.loginSection = false;
              this.router.navigateByUrl('/flightSearch');
            }
            else {
              this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Invalid OTP..!' });
            }
          });
        } catch (e) { }
      }

      private fetchUserPermissions(agencyId: string, userId: string) {
        this.userService.GetUsersNavMenu(agencyId, userId).subscribe({
          next: (data) => {
              if (data.reportUserRights) {
                data.reportUserRights = this.getLatestReportRights(data.reportUserRights);
              }
              this.authservice.setNavMenu(data);
              // Store insurance rights separately if needed
              localStorage.setItem("InsuranceRights", JSON.stringify({
              "issue": data.insuranceIssuanceRight,
              "view": data.insuranceBookedViewRight,
              "cancel": data.insuranceCancelRight
            }));
          },
          error: (error) => {
            console.error('Error fetching user permissions', error);
          }
        });
      }
      private getLatestReportRights(reportRights: any[]): any[] {
        const latestMap = new Map<string, any>();

        reportRights.forEach(right => {
          const existing = latestMap.get(right.reportTypeName);

          if (!existing) {
            // First entry for this report type
            latestMap.set(right.reportTypeName, { ...right });
          } else {
            // Compare IDs - keep the one with higher reportAgencyRightId (newer)
            if (right.reportAgencyRightId > existing.reportAgencyRightId) {
              latestMap.set(right.reportTypeName, { ...right });
            }
          }
        });

        return Array.from(latestMap.values());
      }
      validatePassword() {
        var st = document.getElementById('password') as HTMLInputElement;
        var stu = document.getElementById('confirm_password') as HTMLInputElement;
        if (st.value != stu.value) {
          document.getElementById('message')!.style.color = 'red';
          document.getElementById('message')!.innerHTML = 'Password is not Matched';
          this.valid = false;
    
        } else {
          this.valid = true;
          document.getElementById('message')!.innerHTML = '';
        }
        return this.valid;
      }
      UpdateNewUserPassword() {
        if (this.validatePassword() == false) {
          return;
        };
        try {
          /*      console.log(this.loginCred);*/
          var checkv = localStorage.getItem("UserId");
    
    
          this.cmsService.UpdateNewUserPassword(this.loginCred).subscribe((data) => {
            if (data == true) {
    
              this.router.navigateByUrl('/flightSearch');
            }
          });
        }
        catch (e) {
       
        }
    
      }
    
  handleKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;

    // --- HANDLE PASTE via Ctrl+V (keydown) ---
    if ((event.ctrlKey || event.metaKey) && (event.key === 'v' || event.key === 'V')) {
      event.preventDefault();

      // Try to get clipboard data from the event (not always present on KeyboardEvent)
      const clipboardFromEvent = (event as unknown as ClipboardEvent).clipboardData;
      if (clipboardFromEvent) {
        // Call your existing PasteTheOTP handler with a simulated event shape
        this.PasteTheOTP({
          clipboardData: clipboardFromEvent,
          preventDefault: () => { }
        } as ClipboardEvent);
        return;
      }

      // Fallback: use navigator.clipboard
      if (navigator.clipboard && navigator.clipboard.readText) {
        navigator.clipboard.readText()
          .then(text => {
            const simulatedEvent = {
              clipboardData: {
                getData: () => text
              },
              preventDefault: () => { }
            } as unknown as ClipboardEvent;
            this.PasteTheOTP(simulatedEvent);
          })
          .catch(() => {
            // optional: silent fail or show a small toast
          });
        return;
      }

      // Last fallback: window.clipboardData for old IE
      const winClip = (window as any).clipboardData;
      if (winClip) {
        this.PasteTheOTP({
          clipboardData: winClip,
          preventDefault: () => { }
        } as unknown as ClipboardEvent);
      }

      return;
    }

    // --- NAVIGATION KEYS (allow) ---
    const navKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab'];
    if (navKeys.includes(event.key)) {
      // allow normal navigation (don't preventDefault) — optionally implement arrow-focus logic
      return;
    }

    // --- BACKSPACE handling ---
    if (event.key === 'Backspace') {
      event.preventDefault();

      // If current has a value -> clear it and stay put
      if (this.otp['digit' + index]) {
        this.otp['digit' + index] = '';
        input.value = '';
        return;
      }

      // Current is empty -> move to previous (if exists) and clear it
      if (index > 1) {
        const prevIndex = index - 1;
        const prevInput = document.getElementById('digit' + prevIndex) as HTMLInputElement | null;
        if (prevInput) {
          this.otp['digit' + prevIndex] = '';
          prevInput.value = '';
          prevInput.focus();
        }
      }
      return;
    }

    // --- NUMERIC INPUT handling ---
    // Accept only single digit 0-9
    if (/^[0-9]$/.test(event.key)) {
      event.preventDefault();

      // Set model + UI (keep them in sync)
      this.otp['digit' + index] = event.key;
      input.value = event.key;

      // Move focus to next if present
      if (index < 6) {
        const nextInput = document.getElementById('digit' + (index + 1)) as HTMLInputElement | null;
        nextInput.focus();
      }
      return;
    }

    // Block anything else
    event.preventDefault();
  }

  forgetOpen: boolean = false;
  secretkeyopen: boolean = false;
  forgetPopup() {
    this.forgetOpen = true;
  }
  ShowOTPSection() {
    this.secretkeyopen = false;
    this.otpSection = true;
  }

}
